import cn from 'classnames'
import React, { useContext, useMemo } from 'react'
import { Checked } from '../../../UIkit/components/icons/Checked.tsx'
import { ColorNames } from '../../../UIkit/theme/generated/ColorNames.ts'
import { Colors } from '../../../UIkit/theme/generated/Colors.ts'
import { PageColorContext } from '../../Features/PageColorContext.tsx'
import styles from './checkbox.module.less'
import { CheckboxView } from './checkboxView.ts'

interface CheckBoxProps extends React.HTMLProps<HTMLInputElement> {
    onValueChange?: (value: boolean) => void
    checked?: boolean
    semiChecked?: boolean
    disabled?: boolean
    view?: CheckboxView
    borderColor?: Colors
    pageColor?: boolean
    color?: ColorNames
    colorCSS?: string
}

export const CheckBox: React.FC<CheckBoxProps> = ({
    borderColor,
    semiChecked,
    view = CheckboxView.standard,
    onValueChange,
    checked,
    disabled,
    pageColor,
    color = ColorNames.CORAL_INK,
    colorCSS
}) => {
    const pageColorName = useContext(PageColorContext)

    const style = useMemo(() => {
        const rules = { borderColor }
        if (disabled) rules.borderColor = Colors.Obsidian_Light_200
        if (colorCSS) rules['--checked-bg-color'] = colorCSS
        return rules
    }, [disabled, borderColor, colorCSS])

    return (
        <div
            style={style}
            className={cn(styles.root, styles[view], styles[pageColor ? pageColorName : color], {
                [styles.semiChecked]: semiChecked,
                [styles.checked]: checked,
                [styles.disabled]: disabled
            })}
        >
            <input
                className={styles.input}
                onChange={e => onValueChange && onValueChange(e.target.checked)}
                checked={checked}
                type='checkbox'
            />
            {checked && <Checked />}
        </div>
    )
}
